import app from "../_app";
import axios from "axios";
const minicart = document.querySelector('.js-minicart');

if(minicart) {

    const minicartTriggers = [...document.querySelectorAll('.js-minicart-trigger')];
    const quickAddItems = [...document.querySelectorAll('.js-quickadd')];
    const quickRemoveItems = [...document.querySelectorAll('.js-quickremove')];
    const minicartContent = minicart.querySelector('.js-minicart-content');
    const minicartCount = document.querySelector('.js-minicart-count');

    minicartTriggers.map(minicartTrigger => {

        minicartTrigger.addEventListener('click', e => {
            if(!minicart.hasAttribute('data-open')) {
                minicart.setAttribute('data-open','');
                app.lockBody();
            } else {
                app.unlockBody();
                minicart.removeAttribute('data-open');
            }
        })
    })

    const updateCart = async (id, qty, title, element) => {
        try {

            let cartResponse = await axios.get('/cart.js');
            let proceed = true;
            const digitsOnlyTitle = title.replace(/\D/g, '');



            if(qty !== '0') {
                cartResponse.data.items.map(item => {

                    if (item.variant_title.replace(/\D/g, '') === digitsOnlyTitle) {
                        proceed = false;
                        element.target.dataset.status = 'added';
                        element.target.innerText = window.translations['product.button.allready-in-cart'];
                    }
                });
            }


            console.log('eind:' + proceed);
            if(proceed) {
                let response = await axios.post('/cart/update.js', {updates: {[id]: qty}});

                if (response.status === 200) {
                    let newItems = response.data.items;

                    minicartContent.innerHTML = '';

                    newItems.map(newItem => {
                        let li = document.createElement('li');
                        let img = document.createElement('img');
                        let span = document.createElement('span');
                        let removeLink = document.createElement('a');

                        // removeLink.setAttribute('id', newItem.variant_id);
                        // removeLink.setAttribute('qty', 0);
                        // removeLink.classList.add('js-quickadd');
                        // removeLink.innerText = 'Verwijderen';

                        span.innerHTML = newItem.title
                        img.classList.add('img');
                        img.src = `${newItem.featured_image.url}&crop=center&height=100&width=100`;
                        img.height = 100;

                        li.append(img)
                        li.append(span)
                        li.append(removeLink)
                        minicartContent.appendChild(li);
                    });

                    minicartCount.innerHTML = `(${newItems.length})`

                    return response;
                }
            }

        } catch (err) {
            console.log(err)
         }
    }


    if (quickAddItems) {
        quickAddItems.map(quickAddItem => {
            quickAddItem.addEventListener('click', e => {
                e.preventDefault();
                let id = e.target.dataset.id;
                let qty = e.target.dataset.qty;
                let title = e.target.dataset.title;

                updateCart(id, qty, title, e).then((response) => {

                        if (response.status == 200) {

                            if (response.data.item_count < 3 ) {

                                quickAddItems.map(quickAddItem => {
                                    if (quickAddItem.getAttribute('data-status') !== 'added') {
                                        quickAddItem.setAttribute('data-status', '');
                                    }
                                })

                                if (quickAddItem.dataset.qty == 1) {
                                    minicart.setAttribute('data-open', '');
                                    app.lockBody();

                                    quickAddItem.innerText = window.translations['product.button.remove']
                                    quickAddItem.setAttribute('data-status', 'added');
                                    quickAddItem.setAttribute('data-qty', 0);

                                } else if (quickAddItem.dataset.qty == 0) {

                                    quickAddItem.innerText = window.translations['product.button.quick-add']
                                    quickAddItem.setAttribute('data-status', 'removed');
                                    quickAddItem.setAttribute('data-qty', 1);
                                }

                            } else {
                                minicart.setAttribute('data-open', '');
                                app.lockBody();

                                quickAddItem.innerText = window.translations['product.button.remove']
                                quickAddItem.setAttribute('data-status', 'added');
                                quickAddItem.setAttribute('data-qty', 0);

                                quickAddItems.map(quickAddItem => {
                                    if (quickAddItem.getAttribute('data-status') !== 'added') {
                                        quickAddItem.setAttribute('data-status', 'disabled');
                                    }
                                })
                            }
                        }
                })
                
            })
        })
    }


}
